import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AysCodesStore } from '../../store';
import {
  AysCodeDrgInekTable,
  AysDrgBaseRate,
  AysDrgCodeMainDepartmentTimeSeries,
  AysDrgCodeMainDepartmentTimeSeriesEntry,
} from '@bindoc-projects/code-domain-lib';
import { ApiEndpointKey } from '@bindoc-projects/app-config-domain-lib';

@Injectable({
  providedIn: 'root',
})
export class AysDrgCodeService {
  private _httpClient = inject(HttpClient);
  private _environmentService = inject(BdAppEnvironmentService);

  private _store: AysCodesStore;

  constructor() {
    this._store = new AysCodesStore(this._environmentService.load(ApiEndpointKey.AYS_CODE_URL));
  }

  public mainDepartmentTimeSeries(
    drgName: string,
    httpParams: HttpParams = new HttpParams(),
  ): Observable<AysDrgCodeMainDepartmentTimeSeries> {
    const url = `${this._store.codeByCodeName('G-DRG', drgName)}/main-departments/timeseries`;

    return this._httpClient
      .get<{
        [year: string]: AysDrgCodeMainDepartmentTimeSeriesEntry;
      }>(url, { params: httpParams })
      .pipe(
        map((res) => {
          return new AysDrgCodeMainDepartmentTimeSeries(res);
        }),
      );
  }

  public proceedsTable(
    drgName: string,
    baseRate: AysDrgBaseRate,
    httpParams: HttpParams = new HttpParams(),
  ): Observable<AysCodeDrgInekTable> {
    const url = `${this._store.codeByCodeName('G-DRG', drgName)}/proceeds-table`;
    const body = { baseRate: baseRate.value };

    return this._httpClient
      .post<{
        [department: string]: { [section: string]: number };
      }>(url, body, { params: httpParams })
      .pipe(
        map((res) => {
          return new AysCodeDrgInekTable(res);
        }),
      );
  }
}
